
import Airline from "@/Models/airline";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "TicketHeader",
  props: {
    airline: {
      type: Object as PropType<Airline>,
      required: true,
    },
  },
  setup(props) {
    const airlineName = Airline[props.airline].toLowerCase();

    return {
      airlineName,
    };
  },
});
